import { render } from "./SearchBar.vue?vue&type=template&id=4a901e3d&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "../../assets/scss/document_search_bar.scss?vue&type=style&index=0&id=4a901e3d&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a901e3d"]])

export default __exports__